import { invertedQueryMap } from '@/lib/constants/queryMap';
import { createSelector } from '@/redux/lib/createSelector.js';

const stableObject = Object.freeze({});

const parseSearchParams = (search) => {
  return String(search)
    .trim()
    .replace('?', '')
    .split('&')
    .filter(Boolean)
    .map((n) => n.split('='))
    .reduce((acc, [key, value]) => ({ ...acc, [invertedQueryMap[key] || key]: value }), stableObject);
};

export const locationSearch = (state) => state?.router?.location?.search || '';
export const query = createSelector('query', [locationSearch, (_, key) => key], (search, key) => {
  const parsedQuery = parseSearchParams(search);
  return key === undefined ? parsedQuery : parsedQuery[key];
});
export const type = createSelector('type', [locationSearch], (search) => parseSearchParams(search).type);
